// src/components/MachineTable.js
import React from 'react';
import './Machanedteable.css';

const Machanedteable = () => {
  const headers = [
    'Model',
    'BJ50-V6/S6',
    'BJ90-V6/S6',
    'BJ126-V6/S6',
    'BJ160-V6/S6',
    'BJ200-V6/S6',
  ];
//   const unitRow = [
//     'Unit'
//   ];
  const rows = [
    ['Clamping Force (Ton)', 50, 90, 126, 160, 200],
    ['Opening Stroke (mm)', 265, 320, 350, 440, 490],
    ['Max Daylight (mm)', 575, 680, 750, 940, 1040],
    ['Platen Size (mm)', '480x480', '540x540', '610x610', '705x705', '775x755'],
    ['Bars Space (mm)', '315x315', '360x360', '410x410', '460x460', '510x510'],
    ['Max Mold Height (mm)', 310, 360, 400, 500, 550],
    ['Min Mold Height (mm)', 110, 130, 145, 160, 230],
    ['Ejector Stroke (mm)', 70, 100, 100, 140, 140],
    ['Ejector Force (KN)', 20, 34, 42, 49, 65],
  ];

  return (
    <div className="container"   style={{
    border: '1px solid lightgray',
    padding: '0px',
        marginTop: '10px' 

  }}>
      <h2 className="table-heading">Clamping Unit Specifications</h2>
      <div className="responsive-table">
        <table>
<thead>
  <tr>
    {headers.map((head, index) => (
      <th key={index}  className="unit-row">{head}</th>
    ))}
  </tr>
  <tr>
    <th colSpan={headers.length} className="unit-row">Clamping Unit</th>
  </tr>
</thead>

          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Machanedteable;
